import { defineStore } from 'pinia';
import type { _GettersTree } from 'pinia';
import { NavigationKeyEnum } from '@/types/enums/NavigationKeyEnum';
import type {
    NavigationActivityStateType,
    NavigationActivityGettersType,
    NavigationActivityActionsType,
    NavigationActivityItemType,
} from '@/types/stores/NavigationActivityStoreTypes';

export const useNavigationActivityStore = defineStore<
    'navigationActivityStore',
    NavigationActivityStateType,
    NavigationActivityGettersType & _GettersTree<NavigationActivityStateType>,
    NavigationActivityActionsType
>('navigationActivityStore', {
    state: (): NavigationActivityStateType => ({ activities: { [NavigationKeyEnum.CompanyAdminInsights]: { text: '60%', color: 'error' } } }),
    getters: {
        hasDot:
            (state: NavigationActivityStateType) =>
                (key: NavigationKeyEnum): boolean => {
                    const activity = state.activities[key];

                    return !!activity?.dot || !!activity?.text;
                },
        getActivity:
            (state: NavigationActivityStateType) =>
                (key: NavigationKeyEnum): NavigationActivityItemType | undefined => {
                    return state.activities[key];
                },
    },
    actions: {
        setDot(key: NavigationKeyEnum): void {
            this.activities[key] = { ...this.activities[key], dot: true };
        },
        setActivity(key: NavigationKeyEnum, activity: NavigationActivityItemType): void {
            this.activities[key] = activity;
        },
        clearDot(key: NavigationKeyEnum): void {
            delete this.activities[key];
        },
        reset(): void {
            this.activities = {};
        },
    },
});
